import { render, staticRenderFns } from "./get.vue?vue&type=template&id=f89e316a&scoped=true&"
import script from "./get.vue?vue&type=script&lang=js&"
export * from "./get.vue?vue&type=script&lang=js&"
import style0 from "./get.css?vue&type=style&index=0&id=f89e316a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89e316a",
  null
  
)

export default component.exports